import { forwardRef } from 'react';

export default forwardRef(() => (
  <img
    src="/images/running-status-icon.gif"
    width={20}
    height={20}
    alt="icon"
  />
));
